// nodeOpenPolicy.js
//
// Type-level policy for whether openNode should use Peek by default.

/**
 * Whether opening a node of this type should show Peek (default true).
 * Missing / undefined on the type doc means Peek (backward compatible).
 *
 * @param {object|null|undefined} nodeType
 * @returns {boolean}
 */
export function shouldShowPeekOnOpen(nodeType) {
  return nodeType?.showPeekOnOpen !== false;
}
